ecosystemDesktopAnim = {
    init: function () {
        var controller = new ScrollMagic.Controller();

        var scene = new ScrollMagic.Scene({
            triggerElement: '.section-ecosystem',
            triggerHook: "0.2",
        }).on('start', function () {
            initAnimation();
        }).addTo(controller);

        function initAnimation() {
            var duration = 8; // seconds
            var individualDuration = duration / $(".ecosystem__slider .swiper-slide").length;

            $(".ecosystem__slider .swiper-slide").each(function () {
                var item = $(this);
                var iterationCount = $(this).index();

                console.log(individualDuration);

                var timeout = setTimeout(function () {
                    item.addClass("active");
                }, iterationCount * individualDuration * 1000 * 1.2);
            });

            gsap.to(".progress-bar__fill", {
                width: "100%",
                duration: duration,
                ease: "linear"
            });
        }
    }
};

ecosystemSlider = {
    init: function () {
        var effect = "slide";

        if (window.innerWidth < 991) {
            effect = "fade";
        }

        var swiper = new Swiper(".swiper--ecosystem", {
            slidesPerView: "auto",
            effect: effect,
            fadeEffect: {
                crossFade: true
            },
            pagination: {
                el: ".ecosystem__slider .swiper-pagination",
                type: "progressbar",
            },
            mousewheel: {
                invert: false,
                forceToAxis: true
            }
        });
    }
};

ecosystemThumbsSlider = {
    init: function () {

        const swiperThumbs = new Swiper(".swiper--ecosystem-thumbs", {
            spaceBetween: 0,
            slidesPerView: "auto",
            watchSlidesProgress: true,
        });

        const swiperMain = new Swiper(".swiper--ecosystem-main", {
            loop: false,
            effect: "fade",
            spaceBetween: 0,
            slidesPerView: 1,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            thumbs: {
                swiper: swiperThumbs,
            },
            pagination: {
                el: ".custom-pagination",
                type: "progressbar",
            },
            on: {
                init: function () {
                    updateThumbsSeen(this, swiperThumbs);
                },
                slideChange: function () {
                    updateThumbsSeen(this, swiperThumbs);
                },
                slideChangeTransitionStart: function () {
                    const fill = $('.custom-pagination .swiper-pagination-progressbar-fill');
                    if (!fill.length) return;

                    const totalSlides = this.slides.length - 1;
                    const currentIndex = this.realIndex || 0;
                    const baseProgress = currentIndex / totalSlides;

                    fill.css('transform', `scaleX(${baseProgress})`);
                },

                autoplayTimeLeft: function (swiper, timeLeft, percentage) {
                    const fill = $('.custom-pagination .swiper-pagination-progressbar-fill');
                    if (!fill.length) return;

                    const totalSlides = swiper.slides.length - 1;
                    const currentIndex = swiper.realIndex || 0;
                    const segmentSize = 1 / totalSlides;

                    // percentage = temps que queda
                    // 1 - percentage = temps consumit
                    const segmentProgress = (1 - percentage) * segmentSize;

                    const totalProgress = (currentIndex / totalSlides) + segmentProgress;

                    fill.css('transition', 'none');
                    fill.css('transform-origin', 'left');
                    fill.css('transform', `scaleX(${totalProgress})`);
                }
            }
        });


        function updateProgressBar(swiper) {
            const fill = $('.custom-pagination .swiper-pagination-progressbar-fill');
            const total = swiper.slides.length - 1;

            let progress = swiper.progress;

            console.log("aa");


            fill.css('transform', `scaleX(${progress})`);
        }

        function updateThumbsSeen(mainSwiper, thumbsSwiper) {
            const currentIndex = mainSwiper.activeIndex;

            thumbsSwiper.slides.forEach((slide, index) => {
                if (index <= currentIndex) {
                    slide.classList.add('active');
                } else {
                    slide.classList.remove('active');
                }
            });
        }
    }
};

$(document).ready(function () {
    //ecosystemDesktopAnim.init();
    //ecosystemSlider.init();
    ecosystemThumbsSlider.init();
});